import { IServise } from "@/shared/interfaces/schedulePage";
import { IUpdateOnePayment } from "@/shared/interfaces/patientPage";

type ItemWithPriceOrAmount = IServise | IUpdateOnePayment;

export default function getArraySum(array: ItemWithPriceOrAmount[]): number {
    return array.reduce((accum, item) => {
        const value =
            "price" in item
                ? Number(item.price)
                : "amount" in item
                ? Number(item.amount)
                : 0;
        return accum + value;
    }, 0);
}
